import React from 'react';
const LogoCarousel = () => {
  const logos = [{
    name: 'EY Parthenon',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/pPvaMAYsmbSJPi59SFuyxF/logo_overview.png'
  }, {
    name: 'Ernst & Young',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/5RpTw8waENEjHnNBnGWJsj/pasted-image.png'
  }, {
    name: 'JLL',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/kMdap6LfVZTPNGgeDjcbzd/pasted-image.png'
  }, {
    name: 'Harvard Medical School',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/gXbSkZ9Bm9QNmRiRjTpMzq/harvardmedical.png'
  }, {
    name: 'Yale',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/7Qw1fWREZEBRWqvMkdBy1e/yale.png'
  }, {
    name: 'Blue Cross Blue Shield',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/nxboTv4XTRC8BvbJqNUczb/blue-cross-blue-shield-1-logo-png-transparent.png'
  }, {
    name: 'United Health Group',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/aoeub4QpLrtQSovGrLTzdT/uhg.png'
  }];
  return <div className="logo-carousel-container overflow-hidden border-t border-b border-gray-800 py-3 bg-gray-900/30" data-id="element-162">
      <div className="logo-track flex animate-scroll" data-id="element-163">
        {/* First set of logos */}
        {logos.map((logo, index) => <div key={`logo-1-${index}`} className="logo-item mx-4 flex items-center" data-id="element-164">
            <div className="logo-wrapper rounded-md p-2 flex items-center justify-center h-14 min-w-[120px] bg-white/20 transition-colors" data-id="element-165">
              <img src={logo.url} alt={`${logo.name} logo`} className="max-h-10 max-w-[100px] object-contain" onError={e => {
            console.error(`Failed to load logo: ${logo.url}`);
            const target = e.target as HTMLImageElement;
            target.src = 'https://placehold.co/100x40/gray/white?text=Logo+Error';
          }} data-id="element-166" />
            </div>
          </div>)}
        {/* Duplicate set of logos for seamless loop */}
        {logos.map((logo, index) => <div key={`logo-2-${index}`} className="logo-item mx-4 flex items-center" data-id="element-167">
            <div className="logo-wrapper rounded-md p-2 flex items-center justify-center h-14 min-w-[120px] bg-white/20 transition-colors" data-id="element-168">
              <img src={logo.url} alt={`${logo.name} logo`} className="max-h-10 max-w-[100px] object-contain" onError={e => {
            console.error(`Failed to load logo: ${logo.url}`);
            const target = e.target as HTMLImageElement;
            target.src = 'https://placehold.co/100x40/gray/white?text=Logo+Error';
          }} data-id="element-169" />
            </div>
          </div>)}
      </div>
    </div>;
};
export default LogoCarousel;